import axios from "axios";
import toast from "react-hot-toast";

const BASE_URL = process.env.REACT_APP_API_URL;

const api = axios.create({
  baseURL: BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

api.interceptors.request.use(cfg => {
    if (cfg.url.includes('/ideas/save')) {
    return cfg;
  }
  const startupToken = localStorage.getItem('Startuptoken');
  const startupId = localStorage.getItem('startupId');
  const matrimonyToken = localStorage.getItem('matrimonyToken');
  const mentorToken = localStorage.getItem('mentorToken');

  // 🚀 Guest Mode: skip auth and don't call backend protected routes
  if (startupToken === "DEMO_TOKEN") {
    cfg.headers['X-Demo-Mode'] = 'true';

    // block protected endpoints so they don't throw 401
    if (cfg.url.includes('/api/startups/') || cfg.url.includes('/dashboard')) {
      cfg.adapter = () =>
        Promise.resolve({
          data: { demo: true },
          status: 200,
          statusText: "OK",
          headers: {},
          config: cfg
        });
    }

    return cfg;
  }

  // Normal Auth
  if (startupToken&&startupToken!="DEMO_TOKEN") {
    cfg.headers.Authorization = `Bearer ${startupToken}`;
  } else if (matrimonyToken) {
    cfg.headers.Authorization = `Bearer ${matrimonyToken}`;
  }else if(mentorToken){
     cfg.headers.Authorization = `Bearer ${mentorToken}`;
  }

  return cfg;
});


api.interceptors.response.use(
  res => res,
  err => {
    // Don't handle 401 for login routes
    const isLoginRoute = err.config?.url?.includes('/api/startup-login') ||
      err.config?.url?.includes('/login');

       const isDemo = localStorage.getItem("Startuptoken") === "DEMO_TOKEN"

    if (err.response?.status === 401 && !isLoginRoute&&!isDemo) {
      // token was invalid or expired (but not for login attempts)
      logout();
      return Promise.reject(new Error('session_expired'));
    }
    return Promise.reject(err);
  }
);


export async function registerMatrimony(payload) {
  try {
    const response = await api.post(`${BASE_URL}/api/matrimony/register`, payload, {
      headers: {
        'Content-Type': 'application/json',
      },
    });
    return response.data;
  } catch (error) {
    const message = error.response?.data?.message || 'Failed to register';
    throw new Error(message);
  }
}

export const loginMatrimonyUser = async (email, password) => {
  try {
    const response = await api.post(
      '/api/matrimony/login',
      { email, password },
    );
    return response.data;
  } catch (error) {
    const message = error.response?.data?.message || 'Login failed. Please try again.';
    throw new Error(message);
  }
};

export const getPlans = async () => {
  try {
    const resp = await api.get('/api/subscription-plans');
    return resp.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Failed to fetch subscription plans');
  }
};

// export async function getFounderKyc(founderId) {
//   if (!founderId) {
//     throw new Error('Founder ID is required');
//   }

//   const response = await api.get(`/api/founder-kyc/${founderId}`);
//   if (!response.ok) {
//     const errorText = await response.text();
//     throw new Error(errorText || 'Failed to fetch founder details');
//   }
//   return response.json();
// }

export async function getFounderKyc(founderId) {
  if (!founderId) throw new Error('Founder ID is required');

  try {
    const response = await api.get(`/api/founder-kyc/${founderId}`);
    const result = response.data;

    if (!result.success || !result.data) {
      throw new Error('Founder ID not found');
    }

    return result.data;
  } catch (err) {
    throw new Error(
      err.response?.data?.message || 'Failed to fetch founder details'
    );
  }
}

export const getAllFounderKycs = async () => {
  try {
    const response = await api.get(`/api/founder-kyc`);
    return response.data.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.message || 'Error fetching Founder KYC records'
    );
  }
};

export async function submitFounderKyc(data) {
  try {
    const response = await api.post(`/api/founder-kyc`, data);
    return response.data;
  } catch (error) {
    console.error('Error submitting KYC:', error);
    throw error;
  }
}

export const startupLogin = async (email, password) => {
  try {
    const response = await api.post("/api/startup-login", {
      email,
      password,
    });

    // Save token to localStorage
    if (response.data?.token) {
      localStorage.setItem('Startuptoken', response.data.token);
    }

    return response.data;
  } catch (error) {
    console.log("Login Error:", error);

    const message =
      error.response?.data?.message ||
      error.message ||
      "Login failed. Please try again.";

    throw new Error(message);
  }
};

export const logout = async () => {
  try {
    const response = await api.post("/api/logout");
    localStorage.removeItem("Startuptoken");
    localStorage.removeItem("token")
    toast.error("Session expired please login again.")
    window.location.href="/login"
    return response.data;
  } catch (error) {
    console.error("Logout error:", error);
    throw error;
  }
};

export const createPreference = async (payload) => {
  try {
    // const token = localStorage.getItem('authToken');
    const response = await api.post('/api/preferences', payload);
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Failed to create preference');
  }
};

export const getCountries = async () => {
  try {
    const response = await api.get('/api/countries');
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Failed to fetch countries');
  }
};

export const getStates = async () => {
  try {
    const response = await api.get('/api/states');
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Failed to fetch states');
  }
};

export const getCities = async () => {
  try {
    const response = await api.get('/api/cities');
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Failed to fetch cities');
  }
};

export const getReligions = async () => {
  try {
    const response = await api.get('/api/religions');
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Failed to fetch religions');
  }
};

export const getCastes = async () => {
  try {
    const response = await api.get('/api/castes');
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Failed to fetch castes');
  }
};

export const getGothrams = async () => {
  try {
    const response = await api.get('/api/gothrams');
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Failed to fetch gothrams');
  }
};

export const getDhoshams = async () => {
  try {
    const response = await api.get('/api/dhosams');
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Failed to fetch dhosams');
  }
};

export const getOccupations = async () => {
  try {
    const response = await api.get('/api/occupations');
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Failed to fetch occupations');
  }
};

export const getZodiac = async () => {
  try {
    const response = await api.get('/api/zodiac-signs');
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Failed to fetch zodiac signs');
  }
};

export const getStar = async () => {
  try {
    const response = await api.get('/api/stars');
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Failed to fetch stars');
  }
};

export const getEducation = async () => {
  try {
    const response = await api.get('/api/education');
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Failed to fetch education');
  }
};

export const getMotherTongue = async () => {
  try {
    const response = await api.get('/api/mother-tongues');
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Failed to fetch mother tongues');
  }
};

export const uploadImage = async (imageFile) => {
  try {
    const formData = new FormData();
    formData.append('image', imageFile);

    const response = await api.post('/api/upload/image', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });

    return response.data;
  } catch (error) {
    console.error('Error uploading image:', error);
    throw error;
  }
};

export const createProfileListing = async (payload) => {
  try {
    const response = await api.post('/api/matrimony/profile-listing', payload);
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Failed to create profile listing');
  }
};

export const updateProfileListing = async (id, payload) => {
  try {
    const response = await api.put(`/api/matrimony/profile-listing/${id}`, payload);
    return response.data;
  } catch (error) {
    throw new Error(error?.response?.data?.message || 'Failed to update profile listing');
  }
};


export const getProfileListing = async () => {
  try {
    const response = await api.get('/api/matrimony/get-profiles');
    console.log('API response payload:', response.data);
    const rawData = Array.isArray(response.data)
      ? response.data
      : response.data.data || response.data.profiles || [];
    const verified = rawData.filter(p => p.profile_verified === 1);
    console.log('Verified profiles after filter:', verified);
    return verified;
  } catch (error) {
    console.error('Error fetching profile listings:', error);
    return [];
  }
};

export const getProfileDetails = async (id) => {
  try {
    const res = await api.get(`/api/matrimony/profile-details/${id}`);
    if (!res.data.success) {
      throw new Error(res.data.error || 'Failed to fetch profile details');
    }
    return res.data.data;
  } catch (error) {
    throw new Error(error.response?.data?.error || error.message || 'Failed to fetch profile details');
  }
};

export const createSubscription = async (data, token) => {
  try {
    const resp = await api.post('/api/user-subscriptions', data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return resp.data;
  } catch (error) {
    console.error('Create Subscription error:', error.response || error);
    throw new Error(error.response?.data?.message || 'Failed to create subscription');
  }
};

export const activateStartups = async (id) => {
  try {
    const res = await api.put(`/api/startups/activate/${id}`);

    console.log("mail", res.data)
    if (!res.data.success) {
      throw new Error(res.data.error || 'Failed to activate startup');
    }
    return res.data.data;
  } catch (error) {
    throw new Error(error.response?.data?.error || error.message || 'Failed to activate startup');
  }
};

export const activateEvent = async (eventId, eventRegistrationId) => {
  try {
    const res = await api.post(`/api/event/activate`, {
      eventId,
      eventRegistrationId
    });

    console.log("mail", res.data)
    if (!res.data.success) {
      throw new Error(res.data.error || 'Failed to sent event email');
    }
    return res.data.data;
  } catch (error) {
    throw new Error(error.response?.data?.error || error.message || 'Failed to sent event email');
  }
};

export async function createPayment({ amount, expireAfter, paymentFlow }) {
  // basic validation
  if (typeof amount !== 'number') {
    throw new Error('`amount` must be a number');
  }
  if (typeof expireAfter !== 'number') {
    throw new Error('`expireAfter` must be a number');
  }
  if (
    !paymentFlow ||
    typeof paymentFlow.type !== 'string' ||
    typeof paymentFlow.message !== 'string' ||
    typeof paymentFlow.merchantUrls?.redirectUrl !== 'string'
  ) {
    throw new Error(
      '`paymentFlow` must include `type`, `message`, and `merchantUrls.redirectUrl`'
    );
  }

  console.log('Creating payment with payload:', {
    amount,
    expireAfter,
    paymentFlow
  });
  const payload = { amount, expireAfter, paymentFlow };

  const response = await api.post(
    '/api/create-payment',
    payload,
    {
      headers: {
        'Content-Type': 'application/json'
      }
    }
  );

  return response.data;
}

export async function requestProfileInterest(profileId) {
  try {
    const response = await api.post(
      `/api/matrimony/profile-listing/${profileId}/request`
    );
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Failed to request profile interest');
  }
}

export async function acceptProfileInterest(profileId, requesterId) {
  try {
    const response = await api.post(
      `/api/matrimony/profile-listing/${profileId}/interest/${requesterId}/accept`
    );
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Failed to accept profile interest');
  }
}

export async function denyProfileInterest(profileId, requesterId) {
  try {
    const response = await api.post(
      `/api/matrimony/profile-listing/${profileId}/interest/${requesterId}/deny`
    );
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Failed to deny profile interest');
  }
}

export const getProfileRequests = async () => {
  try {
    const res = await api.get('/api/matrimony/profile-requests');

    if (!res.data) {
      throw new Error('No response from server');
    }

    return res.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.message || error.message || 'Failed to fetch profile requests'
    );
  }
};

export const sendNotification = async (data) => {
  try {
    const res = await api.post(`/api/matrimony/notifications/send`, data);
    return res.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Failed to send notification');
  }
};

export const getNotifications = async (userId) => {
  try {
    const res = await api.get(`/api/matrimony/notifications/${userId}`);
    return res.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Failed to fetch notifications');
  }
};

export const markNotificationRead = async (notificationId) => {
  try {
    const res = await api.post(`/api/matrimony/notifications/read/${notificationId}`);
    return res.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Failed to mark notification as read');
  }
};

export const getEntrepreneurProfiles = async () => {
  try {
    const response = await api.get(
      '/api/profiles/occupation/entrepreneur'
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching entrepreneur profiles:", error);
    throw error;
  }
};

export async function getUserSubscriptions(token) {
  try {
    const res = await api.get('/api/user-subscriptions', {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return res.data.subscriptions;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Failed to fetch user subscriptions');
  }
}

export async function getRequestsSent() {
  try {
    const res = await api.get('/api/matrimony/requests-sent');
    return res.data.sent;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Failed to fetch sent requests');
  }
}

export async function fetchMyProfiles() {
  try {
    const response = await api.get('/api/matrimony/my-profiles', {
    });
    const payload = response.data;
    if (!payload.success) {
      throw new Error(payload.error || 'Failed to fetch profiles');
    }
    return payload.data;
  } catch (err) {
    const message = err.response?.data?.error || err.message || 'Network error';
    throw new Error(message);
  }
}

export const caLogin = async (email, password) => {
  try {
    const response = await api.post("/api/ca-login", { email, password });
    return response.data;
  } catch (error) {
    const message =
      error.response?.data?.error || "Login failed. Please try again.";
    throw new Error(message);
  }
};

export async function getCaForms() {
  try {
    const response = await api.get('/api/caforms');
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || `Error fetching forms: ${error.message}`);
  }
}

export async function getCaFormById(formId) {
  try {
    const response = await api.get(`/api/caforms/${formId}`);
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || `Error fetching form ${formId}: ${error.message}`);
  }
}

export const getCaFormResponses = async (formId) => {
  try {
    const res = await api.get(`/api/caforms/gettickets`);
    return res.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || `Error fetching responses for form ${formId}: ${error.message}`);
  }
};

export const submitCaFormResponse = async (formId, payload) => {
  try {
    const res = await api.post(`/api/caforms/${formId}/responses`, payload);
    return res.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || `Error submitting response for form ${formId}: ${error.message}`);
  }
};

export async function getAllCaFormResponses() {
  try {
    const res = await api.get(`/api/caforms/getalltickets`);
    return res.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Failed to fetch tickets');
  }
}

export async function unlockProfile(id) {
  try {
    const res = await api.post(`/api/matrimony/unlock/${id}`);
    return res.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Failed to unlock profile');
  }
}

export async function getUnlockedProfiles() {
  try {
    const res = await api.get('/api/matrimony/unlocked');
    return res.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Failed to fetch unlocked profiles');
  }
};

export const getFormResponses = async (formId) => {
  try {
    const response = await api.get(`/api/caforms/responses?formId=${formId}`);
    return response.data.responses;
  } catch (error) {
    console.error('Error fetching form responses:', error);
    throw error;
  }
};

export const sendMessage = async (messageData) => {
  try {
    const response = await api.post('/api/caforms/send', messageData);
    return response.data;
  } catch (error) {
    console.error('Error sending message:', error);
    throw error;
  }
};

// export const getCaFormMessages = async (formId) => {
//   try {
//     const res = await api.get(`/api/caforms/${formId}/messages`);
//     return res.data;
//   } catch (err) {
//     console.error('Error fetching CA form messages:', err);
//     throw err;
//   }
// };

// export async function sendCaFormMessage({ formId, sender, message, attachments }) {
//   try {
//     const response = await api.post(
//       `/api/caforms/${formId}/messages`,
//       { sender, message, attachments },
//       { headers: { 'Content-Type': 'application/json' } }
//     );

//     // response.data is { message: "...", data: { … } }
//     if (response.status >= 400) {
//       throw new Error(response.data?.message || 'Failed to send CA form message');
//     }

//     // Return just the `data` object
//     return response.data.data;
//   } catch (error) {
//     throw new Error(error.message || 'Failed to send CA form message');
//   }
// }

function buildEntries(payload) {
  const { _id, data: fields, messages: chatArr, createdAt } = payload;

  const formEntry = {
    id: _id,
    sender: 'client',
    senderName: 'User',
    message: Object.entries(fields)
      .map(([fid, val]) => `**${fid}:** ${val}`)
      .join('\n'),
    attachments: [],
    timestamp: createdAt,
    type: 'form'
  };

  const chatEntries = Array.isArray(chatArr)
    ? chatArr.map(m => ({
      id: m._id,
      sender: m.sender.startsWith('CA') ? 'ca' : 'client',
      senderName: m.sender,
      message: m.message,
      attachments: m.attachments,
      timestamp: m.timestamp,
      type: 'text'
    }))
    : [];

  return [formEntry, ...chatEntries];
}

export async function getCaFormMessages(formId) {
  const res = await api.get(`/api/caforms/${formId}/messages`);
  return res.data || [];
}

// export async function sendCaFormMessage({ formId, sender, message, attachments }) {
//   const res = await api.post(`/api/caforms/${formId}/messages`, {
//     sender,
//     message,
//     attachments,
//   });
//   return buildEntries(res.data.messages || []);
// }

export async function sendCaFormMessage({ formId, sender, message, attachments = [] }) {
  const res = await api.post(`/api/caforms/${formId}/messages`, {
    formId,
    sender,
    message,
    attachments,
  });
  return res.data;  // Return the full response data
}

export const uploadFile = async (file) => {
  try {
    const formData = new FormData();
    formData.append('file', file);
    const res = await api.post('/api/upload/file', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return res.data;
  } catch (err) {
    console.error('Error uploading file:', err.response?.data || err.message);
    throw new Error(err.response?.data?.error || 'Failed to upload file');
  }
};

export const deleteFile = async (publicId, resourceType = 'raw') => {
  try {
    const res = await api.delete('/api/delete/file', {
      data: { publicId, resourceType },
    });
    return res.data;
  } catch (err) {
    console.error('Error deleting file:', err.response?.data || err.message);
    throw new Error(err.response?.data?.error || 'Failed to delete file');
  }
};

export const getFundingRequests = async (startupId) => {
  try {
    const res = await api.get('/api/fundings', { params: { startupId } });
    if (Array.isArray(res.data)) {
      return res.data;
    } else if (Array.isArray(res.data?.data)) {
      return res.data.data;
    } else {
      return [];
    }
  } catch (err) {
    console.error("Error fetching funding requests:", err);
    return [];
  }
};

export const getFounders = async () => {
  try {
    const response = await api.get('/api/founders');
    console.log('Founders response:', response);
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Failed to fetch founders');
  }
};

export const getInterests = async (fundingId) => {
  try {
    const response = await api.get(`/api/interests`, {
      params: { fundingId }
    });
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Failed to fetch interests');
  }
};

export const getFounderById = async (id) => {
  try {
    const response = await api.get(`/api/founders/${id}`);
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || `Failed to fetch founder with id ${id}`);
  }
};

export const createFounder = async (data) => {
  try {
    const response = await api.post('/api/founders', data);
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Failed to create founder');
  }
};

export const updateFounder = async (id, data) => {
  try {
    const response = await api.put(`/api/founders/${id}`, data);
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || `Failed to update founder with id ${id}`);
  }
};

export const deleteFounder = async (id) => {
  try {
    const response = await api.delete(`/api/founders/${id}`);
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || `Failed to delete founder with id ${id}`);
  }
};

export const getUserById = async (id) => {
  try {
    const res = await api.get(`/api/matrimony-user/${id}`);
    return res.data.user;
  } catch (error) {
    throw new Error(error.response?.data?.message || `Failed to fetch user with id ${id}`);
  }
};

export const getMatrimonyUsers = async () => {
  try {
    const res = await api.get('/api/matrimony-users');
    return res.data;
  } catch (err) {
    throw new Error(
      err.response?.data?.message ||
      'Failed to fetch matrimony users'
    );
  }
};

export const getPreferences = async () => {
  try {
    const response = await api.get('/api/preferences');
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Failed to fetch preferences');
  }
};

export const getAllSectors = async () => {
  try {
    const response = await api.get(`/api/sector`);
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Failed to fetch Sectors');
  }
};

export const getAllStages = async () => {
  try {
    const response = await api.get(`/api/stage`);
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Failed to fetch Stages');
  }
};

export const getAllIndustries = async () => {
  try {
    const response = await api.get(`/api/industry`);
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Failed to fetch Industries');
  }
};

export async function fetchPricingData() {
  try {
    const response = await api.get('https://app.zeedone.com/api/v1/pricing');
    return response.data;
  } catch (error) {
    console.error('Error fetching pricing data:', error);
    throw error;
  }
}

export async function fetchFeaturesData() {
  const response = await api.get('https://app.zeedone.com/api/v1/module');
  return response.data.module_with_detail;
}

export async function storeCrmPricing({ userId, planId, title, price, paymentStatus, orderId }) {
  const token = localStorage.getItem('Startuptoken');

  try {
    const response = await api.post(
      '/api/fundings/crmpricing',
      { userId, planId, title, price, paymentStatus, orderId },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error('Failed to store CRM pricing:', error.response?.data || error.message);
    throw error;
  }
}

export async function postMeeting({
  userId,
  name,
  email,
  meetingType,
  meetingDate,
  meetingMode,
  message
}) {
  const payload = {
    userId,
    name,
    email,
    meetingType,
    meetingDate,
    meetingMode,
    message
  };
  const response = await api.post('/api/meetings', payload);
  return response.data;
}


export async function updateFormResponseStatus(formId, status) {
  try {
    const res = await api.post(
      `/api/caforms/${formId}/status`,
      { status }
    );
    return res.data;
  } catch (err) {
    console.error('Error updating form response status:', err);
    throw err;
  }
}

export async function getFormFields() {
  try {
    const res = await api.get('/api/form-fields');
    return res.data;
  } catch (err) {
    console.error('Error fetching form fields:', err);
    throw new Error(err.response?.data?.message || 'Failed to fetch form fields');
  }
}

export const getGateways = async () => {
  try {
    const res = await api.get('/api/payment-gateways');
    return res.data;
  } catch (error) {
    console.error('Error fetching payment gateways:', error);
    throw new Error(error.response?.data?.error || 'Failed to fetch payment gateways');
  }
};

export const getPaymentToken = async (authToken) => {
  try {
    const response = await api.post(`${process.env.REACT_APP_API_URL}/api/auth/tokens`, {
      headers: {
        'Content-Type': 'application/json',
      }
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || 'Failed to get payment token');
    }

    return await response.json();
  } catch (error) {
    console.error('Error getting payment token:', error);
    throw error;
  }
};

export async function createPaymentOrder({ amount, userId, planId, customer_details, return_url }) {
  if (typeof amount !== 'number') {
    throw new Error('`amount` must be a number');
  }

  const payload = { amount, userId, planId, customer_details, return_url };
  const response = await api.post('/api/create-payments', payload, {
    headers: { 'Content-Type': 'application/json' }
  });

  return response.data;
}

export async function verifyPayment(orderId) {
  if (!orderId) {
    throw new Error('Order ID is required');
  }

  const response = await api.post('/api/verify-payment', { orderId }, {
    headers: { 'Content-Type': 'application/json' }
  });

  if (!response.data) {
    throw new Error('Invalid verification response');
  }

  return response.data;
}

export const getTickets = async () => {
  try {
    const res = await api.get('/api/tickets');
    return res.data.data;
  } catch (error) {
    console.error('Error fetching tickets:', error);
    throw error;
  }
};

export const createTicket = async (ticket) => {
  try {
    const res = await api.post('/api/tickets', ticket);
    return res.data.data;
  } catch (error) {
    console.error('Error creating ticket:', error);
    throw error;
  }
};

export const forgotPassword = async (email) => {
  try {
    const response = await api.post('/api/startup/forgot-password', { email });
    return response.data;
  } catch (error) {
    if (error.response) {
      throw new Error(error.response.data.message || 'Failed to send reset email');
    } else if (error.request) {
      throw new Error('No response from server. Please check your connection.');
    } else {
      throw new Error('Error setting up request: ' + error.message);
    }
  }
};

export const resetPassword = async (token, password) => {
  try {
    const response = await api.post(`/api/startup/reset-password/${token}`, { password });
    return response.data;
  } catch (error) {
    if (error.response) {
      throw new Error(error.response.data.message || 'Failed to reset password');
    } else if (error.request) {
      throw new Error('No response from server. Please check your connection.');
    } else {
      throw new Error('Error setting up request: ' + error.message);
    }
  }
};

export async function registerEvent(payload) {
  try {
    const response = await api.post('/api/eventregister', payload);
    return response.data;
  } catch (error) {
    const msg = error.response?.data?.message || 'Failed to register for event';
    throw new Error(msg);
  }
}

export const createCloudCreditApplication = async (applicationData) => {
  try {
    // First upload the file if it's a File object
    let certificateUrl = applicationData.dpittCertificate;

    if (applicationData.dpittCertificate instanceof File) {
      const uploadResponse = await uploadFile(applicationData.dpittCertificate);
      certificateUrl = uploadResponse.url;
    }

    // Prepare the payload
    const payload = {
      ...applicationData,
      dpittCertificateUrl: certificateUrl
    };

    const response = await api.post('/api/applications', payload, {
      headers: {
        'Content-Type': 'application/json'
      }
    });

    return response.data;
  } catch (error) {
    console.error('Submission error:', {
      message: error.message,
      response: error.response?.data
    });

    throw new Error(
      error.response?.data?.error ||
      error.response?.data?.message ||
      'Failed to submit application'
    );
  }
};

// Helper function to convert file to base64
const convertToBase64 = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
  });
};

export const getUserCloudCreditsApplications = async () => {
  try {
    const response = await api.get('/api/applications');
    return response.data;
  } catch (error) {
    const message = error.response?.data?.error || 'Failed to fetch user applications';
    throw new Error(message);
  }
};

export const getCloudCreditsApplicationById = async (applicationId) => {
  try {
    const response = await api.get(`/api/applications/${applicationId}`);
    return response.data;
  } catch (error) {
    const message = error.response?.data?.error || 'Failed to fetch application';
    throw new Error(message);
  }
};

export const getAllCloudCreditsApplications = async ({ status, page = 1, limit = 10 }) => {
  try {
    const response = await api.get('/api/admin/applications', {
      params: { status, page, limit }
    });
    return response.data;
  } catch (error) {
    const message = error.response?.data?.error || 'Failed to fetch all applications';
    throw new Error(message);
  }
};

export const updateCloudCreditsApplicationStatus = async ({ applicationId, status }) => {
  try {
    const response = await api.put(
      `/api/admin/applications/${applicationId}/status`,
      { status }
    );
    return response.data;
  } catch (error) {
    const message = error.response?.data?.error || 'Failed to update application status';
    throw new Error(message);
  }
};

export const createDocumentation = async (documentationData) => {
  try {
    const response = await api.post('/api/documentation', documentationData);
    return response.data;
  } catch (error) {
    console.error('Error creating documentation:', error);
    throw new Error(error.response?.data?.error || 'Failed to create documentation');
  }
};

export const sendOtp = async (email) => {
  try {
    const response = await api.post('/api/auth/send-otp', { email });
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Failed to send OTP');
  }
};

export const verifyOtp = async (email, otp) => {
  try {
    const response = await api.post('/api/auth/verify-otp', { email, otp });
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Failed to verify OTP');
  }
};

export const checkEmail = async (email) => {
  try {
    const response = await api.post('/api/auth/check-email', { email });
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Failed to check email');
  }
};

export const createMentorRequest = async (payload) => {
  try {
    const response = await api.post('/api/mentor-requests', payload);
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Failed to create mentor request');
  }
};

export const getAllMentorRequests = async () => {
  try {
    const response = await api.get('/api/mentor-requests');
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Failed to fetch mentor requests');
  }
};

export const getRequestsByStartup = async (startupId) => {
  try {
    const response = await api.get(`/api/mentor-requests/startup/${startupId}`);
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Failed to fetch requests by startup');
  }
};

export const getRequestsByMentor = async (mentorId) => {
  try {
    const response = await api.get(`/api/mentor-requests/mentor/${mentorId}`);
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Failed to fetch requests by mentor');
  }
};

export const getStartupProfile = async (startupId) => {
  try {
    const response = await api.get(`/api/startups/${startupId}`);
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Failed to fetch startup profile');
  }
};

export const getAllMentors = async () => {
  try {
    const response = await api.get('/api/mentors');
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Failed to fetch mentors');
  }
};

export const getAllMentorsWithoutAuthenticated = async () => {
  try {
    const response = await api.get('/api/mentors');
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Failed to fetch mentors');
  }
};

export const registerInvestor = async (payload) => {
  try {
    const response = await api.post('/api/ourinvestors', payload);
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Failed to register investor');
  }
};

// Login investor
export const loginInvestorAPI = async ({ email, password }) => {
  try {
    const response = await api.post('/api/ourinvestors/login', { email, password });
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Failed to login investor');
  }
}

export const dynamicFieldsAPI = {
  createDynamicField: async (fieldData) => {
    try {
      const response = await api.post(`/api/dynamic-fields`, fieldData, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
      });
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.error || 'Failed to create dynamic field');
    }
  },

  // Get all dynamic fields
  getAllDynamicFields: async () => {
    try {
      const response = await api.get(`/api/dynamic-fields`, {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
      });
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.error || 'Failed to fetch dynamic fields');
    }
  },

  // Get dynamic field by ID
  getDynamicFieldById: async (id) => {
    try {
      const response = await api.get(`/api/dynamic-fields/${id}`, {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
      });
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.error || 'Failed to fetch dynamic field');
    }
  },

  // Update dynamic field
  updateDynamicField: async (id, fieldData) => {
    try {
      const response = await api.put(`/api/dynamic-fields/${id}`, fieldData, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
      });
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.error || 'Failed to update dynamic field');
    }
  },

  // Delete dynamic field
  deleteDynamicField: async (id) => {
    try {
      const response = await api.delete(`/api/dynamic-fields/${id}`, {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
      });
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.error || 'Failed to delete dynamic field');
    }
  },

  // Toggle field status
  toggleFieldStatus: async (id) => {
    try {
      const response = await api.patch(`/api/dynamic-fields/${id}/toggle`, {}, {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
      });
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.error || 'Failed to toggle field status');
    }
  }
};

export const getSectorContacts = async () => {
  try {
    const response = await api.get('/api/sector-contacts');
    return response.data;
  } catch (error) {
    console.error('Error fetching sector contacts:', error);
    throw error;
  }
};

export const getContactsBySector = async (sector) => {
  try {
    const response = await api.get(`/api/sector-contacts/${sector}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching sector contacts:', error);
  }
};

export const updateStartupProfile = async (startupId, data) => {
  try {
    const response = await api.put(`/api/startups/${startupId}/profile`, data);
    return response.data;
  } catch (error) {
    console.error("Error updating startup profile:", error);
    throw error;
  }
};

export const getStartupNotifications = async () => {
  try {
    const startupId = localStorage.getItem('startupId'); // read from localStorage
    if (!startupId) {
      throw new Error('No startupId found in localStorage');
    }

    const response = await api.get(`/api/notifications?userId=${startupId}`);
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Failed to fetch notifications');
  }
};


export const markNotificationAsRead = async (notificationId) => {
  try {
    const response = await api.patch(`/api/notifications/${notificationId}/read`);
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Failed to mark notification as read');
  }
};

export const getCallToAction = async () => {
  try {
    const res = await api.get("/api/call-to-actions");
    return res.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || "Failed to fetch call to action");
  }
};

export const getCouponByCode = async (couponCode) => {
  try {
    const res = await api.get("/api/get-coupon/code/" + couponCode);
    return res.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || "Failed to fetch coupon");
  }
};

export const onSendEmailToBackend = async (body) => {
  console.log(body)
  try {
    const res = await api.post("/api/sendcontact/message", body);
    return res.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || "Failed to Send Email");
  }
}

export const createHRapplication = async (body) => {
  console.log(body)
  try {
    const res = await api.post("/api/hrapplication", body);
    return res.data;
  } catch (error) {
    console.log(error)
    throw new Error(error.response?.data?.message || "Failed to Send Application");
  }
}


export const saveStartupIdea = async (body) => {
  try {
    const res = await api.post('/api/ideas/save', body);

    console.log("🔥 saveStartupIdea API Response:", res);

    return res.data; 
  } catch (error) {
    console.error('Error creating startupidea:', error);
    throw error;
  }
};
export const saveStartupIdeaWithoutPayment = async (body) => {
  try {
    const res = await api.post('/api/ideas/instructions', body);

    console.log("Application sent", res);

    return res.data; 
  } catch (error) {
    console.error('Error creating startupidea:', error);
    throw error;
  }
};
export const fetchActivePrograms = async (query="") => {
  try {
    const res = await api.get(`/api/programfor?for=${query}`);
    console.log(res)
    return res.data; 
  } catch (error) {
    console.error('Error fetching active programs:', error);
    throw error;
  }
};
export const fetchEvents = async (filters={}) => {
  try {
    const res = await api.get(`/api/events`, { params: filters });
    console.log(res)
    return res.data; 
  } catch (error) {
    console.error('Error fetching active programs:', error);
    throw error;
  }
};
export const fetchInvestors = async () => {
  try {
    const res = await api.get(`/api/ourinvestors`);
    console.log(res)
    return res.data; 
  } catch (error) {
    console.error('Error fetching Investors:', error);
    throw error;
  }
};
export const fetchForums = async () => {
  try {
    const res = await api.get(`/api/getstartupforums`);
    console.log(res)
    return res.data; 
  } catch (error) {
    console.error('Error fetching Forums:', error);
    throw error;
  }
};
export const fetchApprovedForumsWithId = async (id) => {
  try {
    const res = await api.get(`/api/approvedforums/${id}`);
    console.log(res)
    return res.data; 
  } catch (error) {
    console.error('Error fetching Forums:', error);
    throw error;
  }
};
export const likeForum = async (id) => {
  try {
    const res = await api.put(`/api/forums/like/${id}`);
    console.log(res)
    return res.data; 
  } catch (error) {
    console.error('Error likeing Forums:', error);
    throw error;
  }
};
export const createForum = async (data) => {
  try {
    const res = await api.post(`/api/createforum`,data);
    console.log(res)
    return res.data; 
  } catch (error) {
    console.error('Error Creating Forums:', error);
    throw error;
  }
};
export const deleteForum = async (id) => {
  try {
    const res = await api.delete(`/api/deleteforums/${id}`);
    console.log(res)
    return res.data; 
  } catch (error) {
    console.error('Error Deleteing Forums:', error);
    throw error;
  }
};

export const updateForum = async (id,data) => {
  try {
   
    const res = await api.put(`/api/updateforums/${id}`,data);
    return res.data; 
  } catch (error) {
    console.error('Error updating Forums:', error);
    throw error;
  }
};
export const getApprovedForums = async () => {
  try {
    
    const res = await api.get(`/api/approvedforums`);
    return res.data; 
  } catch (error) {
    console.error('Error fetching appoved Forums:', error);
    throw error;
  }
};
export const addComment = async (id,data) => {
  try {
    const res = await api.post(`/api/forums/comment/${id}`,data);
    return res.data; 
  } catch (error) {
    console.error('Error adding Comments:', error);
    throw error;
  }
};
export const removeComment = async (forumId,commentId) => {
  try {
    const res = await api.delete(`/api/forums/comment/${forumId}/${commentId}`);
    return res.data; 
  } catch (error) {
    console.error('Error adding Comments:', error);
    throw error;
  }
};

// mentor routes

export const onLoginMentor = async (data) => {
  try {
    const res = await api.post(`/api/mentor/login`, data);
    console.log(res)
    return res.data; 
  } catch (error) {
    console.error('Error on login:', error);
    throw error;
  }
};


export const registerMentor = async (data) => {
  try {
    const res = await api.post(`/api/mentor/register`, data);
    console.log(res)
    return res.data; 
  } catch (error) {
    console.error('Error on Register:', error);
    throw error;
  }
};


export const uploadProfileImage = async (file) => {
  const formData = new FormData();
  formData.append("image", file);

  const res = await api.post("/api/upload/image", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });

  return (
    (res?.data?.url) ||
    (res?.data?.data?.url) ||
    (res?.data?.result?.url) ||
    null
  );
};


export const createMeeting = async (data) => {
  try {
    const res = await api.post(`/api/createmeeting`, data);
    console.log(res)
    return res.data; 
  } catch (error) {
    console.error('Error on Creating meeting:', error);
    throw error;
  }
};

export const getMentorsMeetings = async (data) => {
  try {
    const res = await api.get(`/api/mentormeetings`, data);
    console.log(res)
    return res.data; 
  } catch (error) {
    console.error('Error on fetching meeting:', error);
    throw error;
  }
};

export const updateMentorsMeeting = async (id,data) => {
  try {
    const res = await api.put(`/api/updatemeeting/${id}`, data);
    console.log(res)
    return res.data; 
  } catch (error) {
    console.error('Error on updating meeting:', error);
    throw error;
  }
};
export const deleteMeetingMentorsMeeting = async (id) => {
  try {
    const res = await api.delete(`/api/deletemeeting/${id}`);
    console.log(res)
    return res.data; 
  } catch (error) {
    console.error('Error on updating meeting:', error);
    throw error;
  }
};


export const getApplicantsOfMeeting = async (id) => {
  try {
    const res = await api.get(`/api/getmeeting/applicants/${id}`);
    console.log(res)
    return res.data; 
  } catch (error) {
    console.error('Error on fetching Applicants of meeting:', error);
    throw error;
  }
};
export const getAllMeetings = async () => {
  try {
    const res = await api.get(`/api/getallmeetings`);
    console.log(res)
    return res.data; 
  } catch (error) {
    console.error('Error on fetching meetings:', error);
    throw error;
  }
};

export const applyForMeeting = async (data) => {
  try {
    const res = await api.post(`/api/applyForMeeting`,data);
    console.log(res)
    return res.data; 
  } catch (error) {
    console.error('Error on Applying Meeting meetings:', error);
    throw error;
  }
};
export const checkIsAlreadyApplied = async (data) => {
  try {
    const res = await api.post(`/api/isAlreadyApplied`,data);
    console.log(res)
    return res; 
  } catch (error) {
    console.error('Error on Checking is already applied:', error);
    throw error;
  }
};
export const getMentorMeetingsForStartups = async (id) => {
  try {
    const res = await api.get(`/api/meetings/mentor/${id}/upcoming`);
    console.log(res)
    return res.data; 
  } catch (error) {
    console.error('Error on fetching mentor meetings:', error);
    throw error;
  }
};
export const getStartupAppliedMeetings = async (id) => {
  try {
    const res = await api.get(`/api/getstartupmeetings`);
    console.log(res)
    return res.data; 
  } catch (error) {
    console.error('Error on fetching Startup Applied meetings:', error);
    throw error;
  }
};
export const getMentorDashboard = async (id) => {
  try {
    const res = await api.get(`/api/mentordashboard`);
    console.log(res)
    return res.data; 
  } catch (error) {
    console.error('Error on fetching Startup Applied meetings:', error);
    throw error;
  }
};
export const onPitchdeck = async (data) => {
  try {
    const res = await api.post(`/api/pitchdeck`,data);
    console.log(res)
    return res.data; 
  } catch (error) {
    console.error('Error Submitting pitchdeck:', error);
    throw error;
  }
};

export const checkGoogleTokenExists= async (id) => {
  try {
    const res = await api.get(`/api/google/checktokens`);
    console.log(res)
    return res.data; 
  } catch (error) {
    console.error('Error on fetching Startup Google Tokens:', error);
    throw error;
  }
};
export const googleConnect= async (id) => {
  try {
    const res = await api.get(`/api/google/connect`);
    console.log(res)
    return res.data; 
  } catch (error) {
    console.error('Error on fetching Startup Google Tokens:', error);
    throw error;
  }
};


export const requestPayout = async (data) => {
  try {
    const res = await api.post(`/api/payout/request`,data);
    console.log(res)
    return res.data; 
  } catch (error) {
    console.error('Error Submitting payoutrequest:', error);
    throw error;
  }
};

export const getPayoutRequests= async (id) => {
  try {
    const res = await api.get(`/api/payout/request`);
    console.log(res)
    return res.data; 
  } catch (error) {
    console.error('Error on fetching Payout requests:', error);
    throw error;
  }
};


export default api;
